<ng-container *transloco="let t;">
  <div class="card-header">
    <h4 class="card-title font-medium-1">{{ t('Most active users (Dashboard most active users widget title) - most active users') }}</h4>
  </div>
  <div class="card-body">
    @for(activeUser of (mostActiveUsers$ | async); track activeUser){
      <div class="transaction-item">
        <div class="media align-items-center">
          <div class="avatar bg-light-success rounded">
            <div class="avatar-content">
              <i class="feather font-medium-3 icon-users"></i>
            </div>
          </div>
          <div class="media-body">
            <h6 class="transaction-title">{{ activeUser.name }}</h6>
          </div>
        </div>
        <div><small class="text-muted">{{ activeUser.login_attempts_count }}</small></div>
      </div>
    } @empty {
      <div class="mb-1 p-4 mt-1 text-center cc-no-recordsDiv">
        <p class="text-muted mb-0">{{ t('No records (general) - No records') }}</p>
      </div>
    }
  </div>
</ng-container>